var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReceived(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 107",
    style: {
      enableBackground: "new 0 0 104 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FDE187;}\r\n\t.st1{fill:#FFC71E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_9_",
    x: 23.5,
    y: 27.4,
    className: "st0",
    width: 56.6,
    height: 19.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st1",
    d: "M80.1,25H23.5c-1.3,0-2.4,1.1-2.4,2.4V99c0,2.2,1.3,4.1,3.3,5c2,0.8,4.3,0.4,5.9-1.2 c0.7-0.7,1.6-1.1,2.5-1.1c1,0,1.9,0.4,2.5,1.1c2.1,2.1,4.9,3.2,7.6,3.2c2.8,0,5.5-1.1,7.6-3.2c0.9-0.9,0.9-2.5,0-3.4 c-0.9-0.9-2.5-0.9-3.4,0c-2.3,2.3-6.1,2.3-8.4,0c-3.3-3.3-8.6-3.3-11.9,0c-0.2,0.2-0.4,0.2-0.6,0.1c-0.2-0.1-0.3-0.3-0.3-0.5V48.9 h51.8V99c0,0.2-0.1,0.4-0.3,0.5c-0.2,0.1-0.4,0.1-0.6-0.1c-3.3-3.3-8.6-3.3-11.9,0l-1.9,1.9c-0.9,0.9-0.9,2.5,0,3.4 c0.9,0.9,2.5,0.9,3.4,0l1.9-1.9c0.7-0.7,1.6-1.1,2.5-1.1c1,0,1.9,0.4,2.5,1.1c1.5,1.5,3.9,2,5.9,1.2c2-0.8,3.3-2.8,3.3-5V27.4 C82.6,26.1,81.5,25,80.1,25z M25.9,44V29.8h51.8V44H25.9L25.9,44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st1",
    d: "M70.4,68.1H57c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4h13.4c1.3,0,2.4,1.1,2.4,2.4 C72.8,67,71.7,68.1,70.4,68.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st1",
    d: "M70.4,81.3H57c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4h13.4c1.3,0,2.4,1.1,2.4,2.4 C72.8,80.3,71.7,81.3,70.4,81.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st1",
    d: "M47.3,71.4c-0.9-0.6-2.4-1.2-4.6-1.9v-6.1c0.7,0.2,1.2,0.6,1.6,1.1c0.3,0.5,0.5,1.1,0.5,1.7 c0,0.4,0.4,0.8,0.8,0.8h2.7c0.2,0,0.4-0.1,0.6-0.3c0.2-0.2,0.2-0.4,0.2-0.6c-0.1-2-0.7-3.6-2-4.9c-1.1-1.1-2.6-1.7-4.6-2V58 c0-0.5-0.4-0.8-0.8-0.8h-1.5c-0.5,0-0.8,0.4-0.8,0.8v1.3c-2,0.2-3.5,0.9-4.7,2.2c-1.3,1.4-2,3.1-2,4.9c0,2,0.6,3.7,1.9,4.8 c1.1,1,2.7,1.7,4.8,2.2v6.9c-1-0.2-1.7-0.7-2.1-1.4c-0.2-0.4-0.5-1.2-0.6-2.8c0-0.4-0.4-0.8-0.8-0.8h-2.8c-0.5,0-0.8,0.4-0.8,0.8 c0,2,0.3,3.5,1,4.7c1.1,2.1,3.2,3.3,6.1,3.6v2c0,0.5,0.4,0.8,0.8,0.8h1.5c0.5,0,0.8-0.4,0.8-0.8v-2c1.7-0.3,3-0.7,4-1.3 c2.1-1.3,3.1-3.6,3.1-6.7C49.8,74.3,49,72.6,47.3,71.4z M37.4,66.2c0-0.7,0.2-1.3,0.7-2c0.3-0.4,0.8-0.7,1.4-0.8v5.4 c-0.6-0.2-1-0.5-1.4-0.8C37.6,67.6,37.4,67,37.4,66.2z M42.7,74.3c0.8,0.3,1.2,0.5,1.5,0.7c0.7,0.5,1.1,1.3,1.1,2.3 c0,0.7-0.1,1.3-0.4,1.8c-0.4,0.8-1.1,1.2-2.1,1.4L42.7,74.3L42.7,74.3L42.7,74.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceived);
export default __webpack_public_path__ + "static/media/received.2cb1b3eca64064cec943d7309fd9089d.svg";
export { ForwardRef as ReactComponent };